<template>
  <div class="basket-view">
    <h1>Votre panier</h1>

    <p v-if="products.length <= 0">Votre panier est vide</p>

    <div v-else>
      <div v-for="item in products" v-bind:product="item" v-bind:key="item.id">
        <line-decoupe v-if="item.type === 'cutting'" :product="item"></line-decoupe>
        <line-unitaire v-else :product="item"></line-unitaire>
      </div>
      <send-basket></send-basket>
    </div>
    
  </div>
</template>
<script>

import SendBasket from "@/components/Basket/SendBasket.vue";
import LineDecoupe from "@/components/Basket/LineDecoupe.vue";
import LineUnitaire from "@/components/Basket/LineUnitaire.vue";

export default {
  name: "basket-view",
  data() {
    return {
      products: []
    };
  },
  mounted: function() {
    // Lorsque la vue est monté, on récupère les produits du panier depuis le state global
    this.products = this.$store.state.basket;
  },
  components: {
    LineDecoupe,
    LineUnitaire,
    SendBasket
  }
};
</script>

<style scoped>
h1 {
  font-size: 2.5rem;
}
</style>
